import type { ModelChain } from '@app/api/Chains';
import type { NBranches } from '@app/types';

export const getModelChain = (
  data: Omit<ModelChain, 'ChainBranches'> & {
    ChainBranches: NBranches.BranchesForSystem[];
  }
) => {
  const { ChainBranches, ...rest } = data;

  const result = {
    ...rest,
    ChainBranches: ChainBranches.map((branch) => {
      return {
        BranchId: branch?.Id,
        Name: branch?.Name ?? '',
        IsSelected: true,
      };
    }),
  };

  return result;
};
